import { login, logout, getInfo, wNengKLogin } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { defineStore } from "pinia";

function readUserInfoFromStorage() {
  try {
    const raw = sessionStorage.getItem("userInfo");
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function readTokenFromStorage() {
  return getToken();
}

const useUserStore = defineStore("user", {
  state: () => ({
    token: readTokenFromStorage(),
    id: "",
    name: "",
    avatar: "",
    roles: [],
    permissions: [],
    userInfo: readUserInfoFromStorage(),
  }),
  getters: {
    getToken: (state) => {
      return state.token || getToken();
    },
  },
  actions: {
    login(userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((res) => {
            if (res.success) {
              setToken(res.data.token);
              this.token = res.data.token;
            }
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    wanKeylogin(userId) {
      return new Promise((resolve, reject) => {
        wNengKLogin({ userId })
          .then((res) => {
            if (res.success) {
              setToken(res.data.token);
              this.token = res.data.token;
            }
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getInfo() {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res) => {
            if (res.success) {
              this.setUserInfo(res.data);
            }
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setUserInfo(userInfo) {
      this.userInfo = userInfo || {};
      if (userInfo && Object.keys(userInfo).length) {
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      }
    },
    logOut() {
      return new Promise((resolve) => {
        logout(this.token).finally(() => {
          this.token = "";
          this.roles = [];
          this.permissions = [];
          removeToken();
          sessionStorage.removeItem("userInfo");
          resolve();
        });
      });
    },
  },
});

export default useUserStore;
